import { request } from '@/api/_service.js';
export function listStockMain(params) {
  return request({
    url: '/stockNew/getStockMainList',
    method: 'get',
    params: params
  });
}
export function listStockMainExport(params) {
  return request({
    url: '/stockNew/getStockMainList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
export function listStockOutOrder(params) {
  return request({
    url: '/stockDealer/getStockoutList',
    method: 'get',
    params: params
  });
}
export function listStockDetail(params) {
  return request({
    url: '/stockDealer/getStockoutInfoList',
    method: 'get',
    params: params
  });
} // 出库申请单列表

export function listStockoutApply(params) {
  return request({
    url: '/agent_v3/getOutAppformList',
    method: 'get',
    params: params
  });
} // 查询出库申请单

export function findStockoutApply(params) {
  return request({
    url: '/agent_v3/getOutAppformById',
    method: 'get',
    params: params
  });
} // 创建出库申请单

export function createStockoutApply(data) {
  return request({
    url: '/agent_v3/createOutAppform',
    method: 'post',
    data: data
  });
}
export function updateStockoutApply(data) {
  return request({
    url: '/agent_v3/updateOutAppform',
    method: 'post',
    data: data
  });
} // 删除出库申请单

export function deleteStockoutApply(data) {
  return request({
    url: '/agent_v3/delOutAppform',
    method: 'delete',
    data: data
  });
} // 出库申请单明细详情

export function listStockoutApplyDetail(params) {
  return request({
    url: '/agent_v3/getOutAppformList',
    method: 'get',
    params: params
  });
}